/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { get } from 'lodash';
import NumberFormat from '../../utils/NumberFormat';

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 5,
    marginLeft: 2,
    justifyContent: 'flex-start',
    width: '100%',
  },
  billTo: {
    // padding: 3,
    // fontFamily: 'Helvetica-Oblique',
    fontStyle: 'bold',
    textDecoration: 'underline',
  },
  invoiceDateContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  label: {
    width: 150,
    fontStyle: 'bold',
  },
  conteudo: {
    width: 100,
  },
});

function InvoiceNo({ dados }) {
  const receitas = get(dados, 'Receita', []);
  const comissao = get(dados, 'totalcomissao', 0);
  const totalReceitas = receitas
    .map((item) => parseFloat(item.valor))
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    .toFixed(2);
  const despesas = get(dados, 'Despesas', []);
  const totalDespesas = despesas
    .map((item) => parseFloat(item.valor))
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    .toFixed(2);
  const margem = Number.parseFloat(
    totalReceitas - totalDespesas - comissao
  ).toFixed(2);
  let lucro = 0;
  if (totalReceitas > 0)
    lucro = Number.parseFloat((margem / totalReceitas) * 100).toFixed(2);

  return (
    <View style={styles.headerContainer}>
      <Text style={styles.billTo}>Custo/Faturamento:</Text>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Margem Bruta(R$): </Text>
        <Text style={styles.conteudo}>{NumberFormat(margem)}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Lucro Bruto(%): </Text>
        <Text style={styles.conteudo}>{NumberFormat(lucro)}</Text>
      </View>
    </View>
  );
}

export default InvoiceNo;
